const calcHoursPerYear = (vehicleSet) =>
  (vehicleSet.hoursPerWorkday * vehicleSet.workdays.length * vehicleSet.vehicleCount * 365.25) / 7;

export default calcHoursPerYear;
